import { render, staticRenderFns } from "./DialogImageViewer.vue?vue&type=template&id=cacd648e"
import script from "./DialogImageViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogImageViewer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports